<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height"/>
    </div>
  </div>
</template>

<script>
import {Chart} from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
// import {Colorize} from "@/libs/colorizer";
import annotationPlugin from "chartjs-plugin-annotation";
import moment from "moment";

export default {
  name: "be506b82-1769-11eb-8116-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      hours: [],
      type: [],
      reds: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels, annotationPlugin],
          data: {
            labels: this.type,
            datasets: [
              {
                label: this.chart.report_description,
                data: this.hours,
                maxBarThickness: 800,
                datalabels: {
                  anchor: 'end',
                  clamp: true,
                  align: 'end'
                }
              },
              {
                label: 'Контрольная линия',
                data: this.reds,
                type: 'line',
                order: 0,
                fill: false,
                datalabels: {
                  color: function (value) {
                    return value.dataset.backgroundColor
                  },
                  display: function (value) {
                    if (value.dataIndex === 0) {
                      return true
                    } else {
                      return false
                    }
                  },
                  align: 'end',
                  offset: -11,
                  formatter: function () {
                    return null
                  }
                },
                tooltip: {
                  enabled: false,
                },
                pointRadius: 0
              }
            ]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'start',
                formatter: function (value) {
                  if (value > 0) return value
                  return null
                }
              },
              legend: {
                display: false,
                labels: {
                  filter: function (value) {
                    if (value.text.includes('Контрольная линия')) {
                      return null
                    } else {
                      return {
                        text: value.text,
                      }
                    }
                  }
                }
              }
            },
            scales: {
              y: {
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (Number.isInteger(value)) { return value } },
                  stepSize: 1
                },
                title: {
                  display: true,
                  text: 'Среднее время реакции, ч.'
                }
              }
            }
          }
        });
      }
    },
    update_data: function () {
      this.hours = []
      this.type = []
      this.reds = []

      let red_line = this.chart.report_control_line
      this.hours.push(0)
      this.type.push('')
      this.reds.push(red_line)
      for (let i =0; i < this.chart.report_data.length; i++) {
        this.hours.push(this.chart.report_data[i]["Часы"])
        this.type.push(moment(this.chart.report_data[i]["Месяц"]).format('MMMM').toUpperCase())
        this.reds.push(red_line)
      }
      this.hours.push(0)
      this.type.push('')
      this.reds.push(red_line)
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>